const VerticalScrollableContent = (props: React.PropsWithChildren) => {
    return(
        <div className="scrollable-content">
                {props.children}
            
        </div>
    )
}
export default VerticalScrollableContent